export default __webpack_public_path__ + "static/media/mysteryLogo.4910130f.png";